import { render, staticRenderFns } from "./insights.vue?vue&type=template&id=2fbba6de&scoped=true"
import script from "./insights.vue?vue&type=script&lang=js"
export * from "./insights.vue?vue&type=script&lang=js"
import style0 from "./insights.vue?vue&type=style&index=0&id=2fbba6de&prod&scoped=true&lang=css"
import style1 from "./insights.vue?vue&type=style&index=1&id=2fbba6de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbba6de",
  null
  
)

export default component.exports